import {motion, useReducedMotion} from "framer-motion"


// Entering page slides in from the right and settles over the old one,
// while the exiting page shrinks slightly, shifts left and fades away.
const pageVariants = {
    initial: {
        x: "100%",
        scale: 1,
        opacity: 1,
    },
    enter: {
        x: 0,
        scale: 1,
        opacity: 1,
        transition: {duration: 0.9, ease: [0.32, 0.72, 0, 1]},
    },
    exit: {
        x: "-8%",
        scale: 0.96,
        opacity: 0,
        transition: {duration: 0.75, ease: [0.4, 0, 0.2, 1]},
    },
};

// Fallback for users with "reduce motion" enabled: a quick crossfade.
const reducedMotionVariants = {
    initial: {opacity: 0},
    enter: {opacity: 1, transition: {duration: 0.25, ease: "easeOut"}},
    exit: {opacity: 0, transition: {duration: 0.2, ease: "easeIn"}},
};

const transition = (OgComponent) => {
    return function TransitionedPage() {
        const shouldReduceMotion = useReducedMotion();

        return (
            <motion.div
                className="slide-in"
                variants={shouldReduceMotion ? reducedMotionVariants : pageVariants}
                initial="initial"
                animate="enter"
                exit="exit"
            >
                <OgComponent />
            </motion.div>
        );
    };
};


export default transition;
